import React, { Component } from 'react'
import Included from '../Included'
class Wizard extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
    <section><a className="anchor" id="wizard"></a>

      <h2>Wizard</h2>
      <p>The wizard component can be used when you need to implement a multi-step process. By default, the wizard can contain details of each step in the process, for example &quot;Step 1: Participant Info&quot;. The wizard will respond as the browser window is resized to automatically show/hide the step details as necessary.</p>

      <select className="size-select">
        <option value="auto">Select a resolution</option>
        <option value="482">480px (xs)</option>
        <option value="770">768px (sm)</option>
        <option value="994">992px (md)</option>
        <option value="1202">1200px (lg)</option>
        <option value="1602">1600px (xlg)</option>
      </select>
    <br/><br/>
    <div className="iframe-container" style={{"height":"50px"}}>
      <iframe seamless srcDoc={`
        <html>
          <head>
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
            <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
            <link rel="stylesheet" type="text/css" href="css/commonUI.css">
            <link rel="stylesheet" type="text/css" href="css/styleguide.css">
          </head>
          <body>
            <ul class="wizard flush">
              <li class="wizard__item is-active is-complete">
                <span class="wizard__item-step">Step</span><span class="wizard__item-position">1</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Participant Info</span>
              </li>
              <li class="wizard__item">
                <span class="wizard__item-step">Step</span><span class="wizard__item-position">2</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Background Info</span>
              </li>
              <li class="wizard__item">
                <span class="wizard__item-step">Step</span><span class="wizard__item-position">3</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Program Variations</span>
              </li>
              <li class="wizard__item">
                <span class="wizard__item-step">Step</span><span class="wizard__item-position">4</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Accounts</span>
              </li>
              <li class="wizard__item">
                <span class="wizard__item-step">Step</span><span class="wizard__item-position">5</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Terms of Participation</span>
              </li>
            </ul>
          </body>
          <script src="//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
          <script>
          $(document).ready(function() {
            $items = $('.wizard__item');
            $items.on('click', function() {
              $item = $(this);
              if ($item.is(':first-child') || $item.prev().hasClass('is-complete')) {
                $items.removeClass('is-active');
                $item.addClass('is-active is-complete');
              }
            });
          });
          </script>
        </html>
      `}></iframe>
      </div>

      <br/>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<ul class="wizard">
  <li class="wizard__item is-active is-complete">
    <span class="wizard__item-step">Step</span><span class="wizard__item-position">1</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Participant Info</span>
  </li>
  <li class="wizard__item">
    <span class="wizard__item-step">Step</span><span class="wizard__item-position">2</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Background Info</span>
  </li>
  <li class="wizard__item">
    <span class="wizard__item-step">Step</span><span class="wizard__item-position">3</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Program Variations</span>
  </li>
  <li class="wizard__item">
    <span class="wizard__item-step">Step</span><span class="wizard__item-position">4</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Accounts</span>
  </li>
  <li class="wizard__item">
    <span class="wizard__item-step">Step</span><span class="wizard__item-position">5</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Terms of Participation</span>
  </li>
</ul>`}</code></pre>

      <div className="callout">
        <strong>Note:</strong> The following elements are required for the wizard to behave correctly in responsive mode:
        <ul className="list-dots flush">
          <li><pre className="flush--bottom">&lt;span class="wizard__item-position"&gt;step number&lt;/span&gt;</pre></li>
          <li><pre className="flush--bottom">&lt;span class="wizard__item-title"&gt;step title&lt;/span&gt;</pre></li>
        </ul>
      </div>

      <br/>

      <h3>Simplified Wizard</h3>
      <p>A simplified wizard can be created without including the additional details for each step, i.e. by including <em>only</em> the title of the step.</p>

      <div className="alert alert--warning">
        <strong>Note:</strong> The simplified wizard should only be used for a desktop-only layout, or where there are a limited number of steps in the process, as the simple layout is not fully mobile-optimized.
      </div>

      <br/>

      <p>A basic wizard can be created by applying the <code>wizard</code> class to an unordered list element, together with the <code>wizard__item</code> class each list item within the unordered list, as follows:</p>

      <iframe seamless className="flush" style={{height: 50 + 'px'}} srcDoc={`
        <html>
          <head>
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
            <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
            <link rel="stylesheet" type="text/css" href="css/commonUI.css">
            <link rel="stylesheet" type="text/css" href="css/styleguide.css">
          </head>
          <body>
            <ul class="wizard">
              <li class="wizard__item is-active is-complete">Participant Info</li>
              <li class="wizard__item">Background Info</li>
              <li class="wizard__item">Program Variations</li>
              <li class="wizard__item">Accounts</li>
              <li class="wizard__item">Terms of Participation</li>
            </ul>
          </body>
          <script src="//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
          <script>
          $(document).ready(function() {
            $items = $('.wizard__item');
            $items.on('click', function() {
              $item = $(this);
              if ($item.is(':first-child') || $item.prev().hasClass('is-complete')) {
                $items.removeClass('is-active');
                $item.addClass('is-active is-complete');
              }
            });
          });
          </script>
        </html>
      `}></iframe>

      <pre><code className="language-html">{`<!-- HTML -->
<ul class="wizard">
  <li class="wizard__item is-active is-complete">Participant Info</li>
  <li class="wizard__item">Background Info</li>
  ...
  <li class="wizard__item">Terms of Participation</li>
</ul>`}</code></pre>

      <br/>

      <div className="callout">
        <strong style={{position: 'relative', left: -5 + 'px'}}><i className="fa fa-lightbulb-o fa-lg"></i> Tips</strong>
        <ul className="list-dots flush">
          <li>The sample code provided does not include the functionality for setting the state of each step in the wizard process &ndash; the functionality for setting the state of each step is therefore down to implementation.</li>
          <li>To set the &quot;active&quot; step in the process, apply the <code>is-active</code> class.</li>
          <li>To mark a step as &quot;complete&quot;, apply the <code>is-complete</code> class.</li>
          <li>Applying the <code>is-complete</code> class to a step will automatically &quot;enable&quot; the next step visually &ndash; the actual functionality to enable the step is down to implementation.</li>
          <li>It is recommended that a <em>maximum</em> of five steps be included in the wizard.</li>
        </ul>
      </div>

      <br/>

      <hr/>

    </section>
  )
}
}

export default Wizard



// WEBPACK FOOTER //
// ./styleguide/components/sections/Wizard.js